import { createStore } from 'vuex'

export default createStore({
  state: {
    switchShow:true,
    showType: 0,
  },
  getters: {
    getUserswitchShow: state => state.switchShow,
    getUsershowType: state => state.showType,
  },
  mutations: {
    SET_USER_INFO(state, switchShow) {
      state.switchShow = switchShow
    },
    SET_USER_INFOTwo(state, showType) {
      state.showType = showType
    },
  },
  actions: {
    saveUserswitchShow({ commit }, switchShow) {
      commit('SET_USER_INFO', switchShow)
    },
    saveUsershowType({ commit }, showType) {
      commit('SET_USER_INFOTwo', showType)
    }
  },
  modules: {
  }
})
